/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FormSuccessInformationStatusId } from "../Constants/FormStatus";
import { HtmlAttributes } from "../../../../Common/Constants/HtmlAttributes";
import { BlockTypes } from "../Constants/BlockTypes";
import { isEventManagementForm } from "../Utils/FormUtils";
import { WaitlistOptions } from "./Constants";
import { T } from "../Localization";
var EventFormFeedback = /** @class */ (function () {
    function EventFormFeedback() {
    }
    EventFormFeedback.getFormSuccessInformationStatus = function (form) {
        if (!isEventManagementForm(form)) {
            return null;
        }
        return this.getSessionInformationNotificationStatus(form);
    };
    EventFormFeedback.getSessionSubmissionDetails = function (formElement) {
        return __awaiter(this, void 0, void 0, function () {
            var sessionsBlock, sessionBlockCopy, sessionsFieldset, sessionContainers, selectedSessions, eventSubmitButton, eventSubmissionType, registeredSessions, waitlistedSessions, registeredContainer, fieldset, waitlistedContainer, fieldset;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sessionsBlock = formElement.querySelector("div[".concat(HtmlAttributes.blockType, "=\"Sessions\"]"));
                        if (!sessionsBlock) {
                            return [2 /*return*/, null];
                        }
                        sessionBlockCopy = sessionsBlock.cloneNode();
                        sessionsFieldset = sessionsBlock.querySelector("fieldset.eventSessions");
                        sessionContainers = sessionsBlock.querySelectorAll("div.eventSession");
                        selectedSessions = Array.from(sessionContainers).filter(function (session) {
                            var input = session.querySelector(".eventSessionInput input[name^='msevtmgt_session']");
                            return input === null || input === void 0 ? void 0 : input.checked;
                        });
                        eventSubmitButton = formElement.querySelector("[type=\"submit\"][".concat(HtmlAttributes.dataEventSubmissionType, "]"));
                        eventSubmissionType = eventSubmitButton === null || eventSubmitButton === void 0 ? void 0 : eventSubmitButton.getAttribute(HtmlAttributes.dataEventSubmissionType);
                        registeredSessions = selectedSessions.filter(function (session) {
                            var availableSeats = session.getAttribute(HtmlAttributes.dataAvailableSeats);
                            var isRegistered = availableSeats === "" || parseInt(availableSeats) > 0;
                            return isRegistered && eventSubmissionType !== "waitlist";
                        });
                        waitlistedSessions = selectedSessions.filter(function (session) { return (eventSubmissionType === "waitlist") ||
                            parseInt(session.getAttribute(HtmlAttributes.dataAvailableSeats)) <= 0 &&
                                session.getAttribute(HtmlAttributes.dataWaitlistEnabled) === WaitlistOptions.Yes; });
                        registeredSessions.forEach(function (session) {
                            var input = session.querySelector(".eventSessionInput");
                            if (input) {
                                input.style.display = "none";
                            }
                        });
                        waitlistedSessions.forEach(function (session) {
                            var input = session.querySelector(".eventSessionInput");
                            if (input) {
                                input.style.display = "none";
                            }
                            var waitlistMessage = session.querySelector(".sessionWaitlistMessage");
                            if (waitlistMessage) {
                                waitlistMessage.style.display = "none";
                            }
                        });
                        if (!(registeredSessions.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.createSessionInformationContainer(registeredSessions, "RegisteredSessionsTitle")];
                    case 1:
                        registeredContainer = _a.sent();
                        fieldset = sessionsFieldset === null || sessionsFieldset === void 0 ? void 0 : sessionsFieldset.cloneNode();
                        if (fieldset) {
                            fieldset.appendChild(registeredContainer);
                            sessionBlockCopy.appendChild(fieldset);
                        }
                        _a.label = 2;
                    case 2:
                        if (!(waitlistedSessions.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.createSessionInformationContainer(waitlistedSessions, "WaitlistedSessionsTitle")];
                    case 3:
                        waitlistedContainer = _a.sent();
                        fieldset = sessionsFieldset === null || sessionsFieldset === void 0 ? void 0 : sessionsFieldset.cloneNode();
                        if (fieldset) {
                            fieldset.appendChild(waitlistedContainer);
                            sessionBlockCopy.appendChild(fieldset);
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/, sessionBlockCopy];
                }
            });
        });
    };
    EventFormFeedback.getCanceledSessionDetails = function (formElement) {
        return __awaiter(this, void 0, void 0, function () {
            var canceledSessionsListingContainer, sessions, sessionsContainer, sessionCount, sessionListingSubtext, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        canceledSessionsListingContainer = document.createElement("div");
                        canceledSessionsListingContainer.className = "sessionCancelationFeedbackContainer";
                        sessions = formElement.querySelectorAll('.eventSessions .eventSession');
                        sessionsContainer = document.createElement("div");
                        sessionCount = 0;
                        sessions.forEach(function (session) {
                            var checkbox = session.querySelector('input[type="checkbox"]');
                            var description = session.querySelector('.eventSessionDescription');
                            if (checkbox && checkbox.checked && description) {
                                sessionsContainer.appendChild(description);
                                sessionCount++;
                            }
                        });
                        if (!(sessionCount > 0)) return [3 /*break*/, 2];
                        sessionListingSubtext = document.createElement("p");
                        _a = sessionListingSubtext;
                        return [4 /*yield*/, T("UnregisteredFromFollowingSessions")];
                    case 1:
                        _a.textContent = _b.sent();
                        sessionListingSubtext.className = "sessionCancelationListingSubtext";
                        canceledSessionsListingContainer.appendChild(sessionListingSubtext);
                        canceledSessionsListingContainer.appendChild(sessionsContainer);
                        _b.label = 2;
                    case 2: return [2 /*return*/, canceledSessionsListingContainer];
                }
            });
        });
    };
    EventFormFeedback.showSessionsBlocks = function (form) {
        for (var i = 0; i < form.FormPlaceholders.length; i++) {
            var placeholder = form.FormPlaceholders[i];
            var sessionsBlocks = Array.from(placeholder.Element.querySelectorAll("div[".concat(HtmlAttributes.blockType, "=\"").concat(BlockTypes.blockTypeSessions, "\"]")));
            sessionsBlocks.forEach(function (block) {
                if (block && block instanceof HTMLElement) {
                    block.style.display = "block";
                }
            });
        }
    };
    EventFormFeedback.getSessionInformationNotificationStatus = function (form) {
        for (var i = 0; i < form.FormPlaceholders.length; i++) {
            var placeholder = form.FormPlaceholders[i];
            var sessionsBlocks = Array.from(placeholder.Element.querySelectorAll("div[".concat(HtmlAttributes.blockType, "=\"").concat(BlockTypes.blockTypeSessions, "\"]")));
            if (sessionsBlocks.length > 0 &&
                !sessionsBlocks.some(function (block) { var _a; return ((_a = block.getAttribute(HtmlAttributes.dataRequired)) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "true"; })) {
                var sessionContainers = placeholder.Element.querySelectorAll("div.eventSession[".concat(HtmlAttributes.dataAvailableSeats, "]"));
                var availableSeats = Array.from(sessionContainers).map(function (session) { return session.getAttribute(HtmlAttributes.dataAvailableSeats); });
                if (availableSeats.every(function (value) { return parseInt(value) <= 0; })) {
                    return FormSuccessInformationStatusId.SessionsFullyBookedEventHasCapacity;
                }
            }
        }
        return FormSuccessInformationStatusId.None;
    };
    EventFormFeedback.createSessionInformationContainer = function (sessions, containerTitle) {
        return __awaiter(this, void 0, void 0, function () {
            var container, title, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        container = document.createElement("div");
                        container.className = "sessionInformationContainer";
                        title = document.createElement("h3");
                        _a = title;
                        return [4 /*yield*/, T(containerTitle)];
                    case 1:
                        _a.textContent = _b.sent();
                        title.className = "sessionInformationTitle";
                        container.appendChild(title);
                        sessions.forEach(function (session) {
                            container.appendChild(session);
                        });
                        return [2 /*return*/, container];
                }
            });
        });
    };
    return EventFormFeedback;
}());
export { EventFormFeedback };
